import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro de provincias */
    provincias: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    pais: null,

    /* Seleccion de provincias */
    paisId: 0,
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.provincias = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.pais = null;
    },

    'INICIALIZAR_PROVINCIAS'(state) {
        state.provincias = [];
    },
    'PROVINCIAS'(state, provincias) {
        state.provincias = provincias;
    },
    'PROVINCIAS_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST' (state, paisId) {
        state.paisId = paisId;
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, provincias) {
        state.list = provincias;
        state.selectList = provincias.map(provincia => provincia.nombre.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getProvincias: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PROVINCIAS');

            let queryString = ''
            if ( state.paginaActual != 0) {
              queryString = '?'
                + 'pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.nombre != '') {
                if (queryString == '') {
                    queryString += '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            if (state.pais) {
                if (state.pais.id != 0) {
                    queryString += '&paisId=' + state.pais.id;
                }
            }
      
            apiAxios.get('provincias' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PROVINCIAS_PAGINATION', params);
                    }
                    commit('PROVINCIAS', res.data)
                    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })                
    },
    getList: ({ commit }, paisId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST', paisId);

            let queryString = ''
            if (paisId != 0) {
              queryString = '?paisId=' + paisId;
            }

            apiAxios.get('provincias/list' + queryString)
                .then(res => {
                    commit('SET_LIST', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })                
    },
};

const getters = {
    getField,

    paisId (state) {
        return state.paisId;
    },
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}